// Shared DOMPurify allow-list for broadcast email HTML. Imported by BOTH the
// browser sanitizer (src/lib/sanitizeHtmlClient.ts, live preview) and the
// server sanitizer (server/lib/sanitizeHtml.ts, the HTML stored on each
// BroadcastSend + handed to SendGrid) so the composer preview and the actual
// email are sanitised identically.
//
// Deliberately Vite-free (no DOM / dompurify import) so the server can pull it
// in without dragging anything browser-specific into its graph — same posture
// as src/lib/allowedEmails.ts.
//
// Scope: the markdown toolbar offers bold / italic / lists / links, but the
// body is free-form markdown so headings, blockquotes, and code are tolerated
// too. Everything outside this set (scripts, iframes, event handlers, style
// attributes, data:/javascript: URLs) is stripped. DOMPurify's default URI
// scheme filter already drops javascript:/data: hrefs; the explicit ALLOWED_*
// arrays keep the surface tight rather than relying on defaults alone.
export const BROADCAST_HTML_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'u',
  's',
  'a',
  'ul',
  'ol',
  'li',
  'blockquote',
  'h1',
  'h2',
  'h3',
  'h4',
  'hr',
  'code',
  'pre',
  'span',
] as const;

export const BROADCAST_HTML_ALLOWED_ATTR = ['href', 'title', 'target', 'rel'] as const;

// The object shape DOMPurify.sanitize() expects. Kept as a plain readonly
// object so this module imports nothing; each sanitiser spreads it into the
// sanitize() call.
export const BROADCAST_HTML_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [...BROADCAST_HTML_ALLOWED_TAGS],
  ALLOWED_ATTR: [...BROADCAST_HTML_ALLOWED_ATTR],
};
